import {Component, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {SubSink} from "@Common/core/utils/subsink";
import {Box} from '../../../common/services/box/box.model';
import {BoxService} from '../../../common/services/box/box.service';
import {HelperIndividuService} from "app/archivage/common/services/helper-individu/helper-individu.service";

@Component({
  selector: 'app-boite',
  templateUrl: './boite.html',
  styleUrls: ['./boite.scss', './../../../common/components/versement-consult.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BoiteComponent implements OnInit {
  subSink = new SubSink();
  @Input() box: Box;
  constructor(
    public boxSvc: BoxService,
    public individuSvc: HelperIndividuService
  ) {}

  ngOnInit(): void {

  }
}
